import { Loader2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

interface RecommendFromDocumentsButtonProps {
  onClick: () => void;
  isPending: boolean;
  /** False when the genie has no knowledge sources to read. */
  hasSources: boolean;
}

/**
 * The "Recommend from my documents" affordance shared by the Genie Page
 * editor's cards — one look for every slice the genie can draft from its
 * sources.
 */
export const RecommendFromDocumentsButton = ({
  onClick,
  isPending,
  hasSources,
}: RecommendFromDocumentsButtonProps) => (
  <Button
    type="button"
    variant="outline"
    size="sm"
    onClick={onClick}
    disabled={!hasSources || isPending}
    className="gap-1.5"
  >
    {isPending ? (
      <Loader2 className="h-3.5 w-3.5 animate-spin" />
    ) : (
      <Sparkles className="h-3.5 w-3.5 text-genie-primary" />
    )}
    {isPending ? "Reading your sources…" : "Recommend from my documents"}
  </Button>
);

export default RecommendFromDocumentsButton;
